<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" id="part-1">
<div class="heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper"><span class="element-number-term">PART</span> <span class="element-number-number">ONE</span></h1>
</div>
<h2 class="element-subtitle case-upper">UNDERGROUND</h2>
</div>
</div>
</div>
<div class="text" id="part-1-text">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?4ef121a5